import React from "react";
import { Box } from "rizzui/box";
import { Text } from "rizzui/typography";
import cn from "../../../lib/utils/class-name";

export default function FormBox({
  title,
  subtitle,
  containerClass,
  children,
  parentClass,
}) {
  return (
    <Box
      className={cn(
        "h-fit md:w-fit w-[96%] border-muted border-[.5px] rounded-[8px] p-[20px] md:p-[32px] flex flex-col gap-[10px]",
        parentClass
      )}
    >
      <Box className={cn("flex flex-col gap-[32px]", containerClass)}>
        <Box className="flex flex-col gap-[8px]">
          <Text className="font-ibmPlexSerif text-[18px] leading-[23.4px] font-[600] text-primary-dark">
            {title}
          </Text>
          <Text className="font-switzer text-[14px] leading-[18.48px] font-[400] text-[#758599]">
            {subtitle}
          </Text>
        </Box>
        <Box>{children}</Box>
      </Box>
    </Box>
  );
}
